import { AuthProvider } from "@refinedev/core";
import axios from "axios";
export const TOKEN_KEY = "refine-auth";

export const authProvider: AuthProvider = {
  login: async ({ accessToken, ...rest }) => {
    const url = process.env.REACT_APP_API_REST_URL ?? "http://localhost:8000";
    const result = await axios.post(`${url}/auth/login`, {
      phoneNumber: rest.email,
      otp: rest.password,
    });

    if (result.data.accessToken) {
      localStorage.setItem(TOKEN_KEY, result.data.accessToken);
      return {
        success: true,
        redirectTo: "/",
      };
    }
    return {
      success: false,
      error: new Error("username: admin, password: admin"),
    };
  },
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    return Promise.resolve({
      success: true,
      redirectTo: "/login",
    });
  },
  onError: () => Promise.resolve({ error: { message: "Auth error", name: "AuthError" } }),
  check: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      return Promise.resolve({ authenticated: true });
    }

    return Promise.resolve({
      authenticated: false,
      logout: true,
      redirectTo: "/login",
    });
  },
  getPermissions: () => Promise.resolve(),
  getIdentity: async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      return Promise.reject();
    }

    return Promise.resolve({ name: "Admin", avatar: undefined, token });
  },
};
